import React from "react";
import { Gift } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-brand-cream2 bg-brand-cream2/40">
      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-full bg-brand-green flex items-center justify-center">
              <Gift className="w-4 h-4 text-brand-cream" />
            </span>
            <span className="font-serif text-lg font-semibold">Choicefully</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
            Thoughtful gift discovery for the UK. Answer a few questions and get a curated,
            explained shortlist in about 60 seconds.
          </p>
        </div>
        <div className="text-sm">
          <p className="font-mono uppercase tracking-widest text-xs text-muted-foreground mb-3">Explore</p>
          <ul className="space-y-2">
            <li><Link to="/quiz" className="hover:text-brand-green">Find My Gift</Link></li>
            <li><Link to="/browse" className="hover:text-brand-green">Browse Ideas</Link></li>
            <li><Link to="/saved" className="hover:text-brand-green">Saved Recipients</Link></li>
          </ul>
        </div>
        <div className="text-sm">
          <p className="font-mono uppercase tracking-widest text-xs text-muted-foreground mb-3">Good to know</p>
          <p className="text-muted-foreground leading-relaxed">
            No account needed to start. All prices, retailers and links come from our catalogue —
            never invented. Prices in £ GBP.
          </p>
          <p className="text-muted-foreground leading-relaxed mt-3" data-testid="footer-affiliate-disclosure">
            Some outbound links are affiliate links, so Choicefully may earn a commission when you buy
            through them — at no additional cost to you. We record an anonymous reference for the click
            so the retailer can credit it; we never share your name, email or who the gift is for.
          </p>
        </div>
      </div>
      <div className="border-t border-brand-cream2 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Choicefully UK · A gift discovery demo
      </div>
    </footer>
  );
}
